import { AdminContainer } from "../container";
import React from "react";

export function DiscountScreen({ children }: { children: React.ReactNode }) {
    return <AdminContainer>{children}</AdminContainer>;
}
